import Mock, { Random } from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

Random.extend({
  jobstatus() {
    const status = ['练习中', '考试中', '未开始', '已结束'];
    return this.pick(status);
  },
  pattern() {
    const p = ['练习模式', '考试模式'];
    return this.pick(p);
  },
});

export function queryJobDetailList(data: AjaxDate) {
  const { pageNo = 1, pageSize = 15, totalRecords = 100 } = JSON.parse(data.body);
  return new MockRequest(
    Mock.mock({
      [`list|${pageSize}`]: [{
        id: '@guid',
        userId: '+1',
        userName: '@cname(2,20)',
        finishStatus: '@JOBSTATUS',
        jobScore: '@integer(1,100)',
        rank: '@integer(1,999)',
      }],
      pageNo,
      pageSize,
      totalRecords,
    }), '请求成功', true,
  );
}

export function delJobDetailListItem(data: AjaxDate) {
  const { ids } = JSON.parse(data.body);
  return new MockRequest(
    ids, '删除成功', true,
  );
}

export function test() { return {}; }
